<template>
  <div id="add-update-packet-dialog" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading' && category == null" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-row :gutter="10" class="tab-packet-contents" v-if="category">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.titleMsg2") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="text" v-model="category.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="category.isActivePacketLimitations = !category.isActivePacketLimitations">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.packageRestriction") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.packageRestrictionMsg") }}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="category.isActivePacketLimitations"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="category.isActivePacketLimitations">
                    <div class="custom-radio-table-title">
                      <div></div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.show") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.required") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.hide") }}</div>
                    </div>
                    <div class="custom-radio-table-title base" v-for="packet in category.packetLimitations" :key="packet.packetId + 'selectPacketd'">
                      <div v-if="currentRegisterForm.packets.some(x => x.id == packet.packetId)">{{ currentRegisterForm.packets.find(x => x.id == packet.packetId).title }}</div>
                      <div>
                        <el-radio v-model="packet.type" :label="0">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.show") }}</el-radio>
                      </div>
                      <div>
                        <el-radio v-model="packet.type" :label="1">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.required") }}</el-radio>
                      </div>
                      <div>
                        <el-radio v-model="packet.type" :label="2">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.hide") }}</el-radio>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="category.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="category.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="category.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && category != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.close") }}</el-button>
        <template v-if="id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveCategory'" :disabled="loading == 'saveCategory'" @click="saveCategory">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import { quillEditor } from "vue-quill-editor";
export default {
  props: ["id", "formId"],
  components: {
    quillEditor,
    draggable
  },
  data() {
    return {
      axios,
      settingsDock: false,
      inputVisible: false,
      tagText: null,
      packet: null,
      category: null,
      loading: false,
      validationErrors: [],
      drag: false,
      currDate: new Date().getTime(),
      timeout: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ indent: "-1" }, { indent: "+1" }]
          ],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      }
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    packetForm() {
      return this.$store.getters.getRegistrationPacketForm;
    },
    categoryForm() {
      return this.$store.getters.getRegistrationCategoryForm;
    },
    currentRegisterForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    await this.checkedId();
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.id);
      this.$emit("closeDialog");
    },
    async saveCategory() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "saveCategory";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addOrUpdateRegisterCategory", this.category);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.closeMe();
        }
        this.loading = false;
      }, 500);
    },

    closeMe() {
      this.$emit("closeDialog");
    },

    async checkedId() {
      this.loading = "updateScreenLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.id) {
          this.category = JSON.parse(JSON.stringify(this.currentRegisterForm.additionalServiceCategories.find(x => x.id == this.id)));
          this.category.packetLimitations = this.category.packetLimitations.filter(x => this.currentRegisterForm.packets.some(y => y.id == x.packetId));
        } else {
          this.category = JSON.parse(JSON.stringify(this.categoryForm));
          this.category.registrationFormId = this.formId;
          this.category.packetLimitations = [];
          this.currentRegisterForm.packets.map(x => {
            var payload = {
              packetId: x.id,
              title: x.title,
              stock: x.stock
            };
            this.category.packetLimitations.push(payload);
          });
        }
        this.loading = false;
      }, 500);
    }
  },
  watch: {
    id() {
      this.checkedId();
    }
  }
};
</script>

<style lang="less">
.tab-packet-contents {
  & > .el-col {
    margin-bottom: 1rem;
  }
  .el-input-number {
    width: 100%;
  }
  .registerform-input-container {
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
        margin-top: 1rem;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      height: 120px;
      .el-icon-upload {
        font-size: 30px;
        margin: 0;
      }
    }
  }
  .packet-head {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 10px;
    font-weight: bold;
  }
}
.add-update-packet-dialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.add-update-packet-dialog-container {
  .bottom {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
}

.add-pricing-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.input-new-tag {
  width: 100px;
}
.photo-walls {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .photo-item {
    position: relative;
    .photo-delete-icon {
      position: absolute;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        color: white;
        font-size: 12px;
      }
      border-radius: 50%;
      background-color: red;
      cursor: pointer;
      right: -0.2rem;
      top: -0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/addOrUpdateRegistrationCategory.vue